import type { CSSObject } from "@emotion/react";

export const wrapperCss: CSSObject = {
  /* 
  This is a temporary fix. As soon as the pagination style of the previous element (Reading skills table)
  is fixed, we can set marginTop as 32px and remove the paddingTop.  
  */
  paddingTop: "32px",
};
